'use strict'
import controller from './lista-cierre.controller';
import template from './lista-cierre.html';

const ListaCierre = {
	bindings:{
		proyecto: '=',
		modoVista: '<'
	},
	controller,
	template
};

export default ListaCierre;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/lista-cierre/lista-cierre.component.js